import { createContext, useContext } from 'react'

import type { LinkComponent, LinkComponentProps } from '../ui/Link'

export type LinkComponentProviderProps = {
  children: React.ReactNode
  linkComponent?: LinkComponent
}

function DefaultLinkComponent(props: LinkComponentProps) {
  return <a {...props} />
}

const LinkComponentContext = createContext<LinkComponent>(DefaultLinkComponent)

export function LinkComponentProvider({
  children,
  linkComponent = DefaultLinkComponent,
}: LinkComponentProviderProps) {
  return (
    <LinkComponentContext.Provider value={linkComponent}>
      {children}
    </LinkComponentContext.Provider>
  )
}

export const useLinkComponent = () => useContext(LinkComponentContext)
